<template>
  <div class="mycollection">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div
        class="my-box m_b30"
        v-for="(item, id) in list"
        :key="id"
        @click="checkInfo(item.id)"
      >
        <div class="flex flex-justify-between m_b30">
          <div class="flex flex-pack-center flex-1">
            <img :src="item.avatar" class="avatar-pic m_r20" />
            <div>
              <p class="font-size32 m_b20">{{ item.title }}</p>
              <p class="font-size28 color_99">
                 {{ item.createTime.split(" ")[0] }}
              </p>
            </div>
          </div>
          <div class="font-size28 color_FF00">已收藏</div>
        </div>
        <div class="my-inner-box">
          <div class=" tale-layout">
            <div class="my_text_center font-size24 text">
              <p class="font-size32 m_b20">{{ item.title }}</p>
              <div class="tm">{{ item.author }}</div>
              <div class="tm">{{item.sort}}</div>
              
              
              <!-- <p class="font-size32 m_b20">{{ item.workContentMList }}</p> -->
            </div>
            <div class="flex flex-justify-around flex-pack-center">
              <!-- <img
                  src="@/assets/images/share.png"
                  alt=""
                  class="tale-good-pic m_b20"
                  @click="share"
                /> -->
              <div class="flex flex-pack-center">
                <img
                  src="@/assets/images/my-collec.png"
                  alt=""
                  class="re-layout-icon m_r20"
                />
                <div class="font-size32">{{ item.collectNum }}</div>
              </div>
              <div class="flex flex-pack-center">
                <img
                  src="@/assets/images/good.png"
                  alt=""
                  class="re-layout-icon m_r20"
                />
                <div class="font-size32">{{ item.likeNum }}</div>
              </div>
            </div>

            <!-- <div class="tale-info-right-take" v-if="data">
              <div class="tale-avatar-img m_b50">
                <img :src="avatar" class="tale-img" alt="" />
                <div class="flex flex-justify-center">
                  <img
                    src="@/assets/images/atten-no.png"
                    alt=""
                    class="r-les"
                    @click="voteAtten"
                    v-if="isAttention"
                  />
                  <img
                    src="@/assets/images/atten-r.png"
                    alt=""
                    class="r-les"
                    @click="voteAtten"
                    v-else
                  />
                </div>
              </div>
              <div class="my_text_center tale-good m_b50">
                <img
                  src="@/assets/images/big-good.png"
                  alt=""
                  class="tale-good-pic m_b20"
                  @click="voteLike"
                  v-if="isLike"
                />
                <img
                  src="@/assets/images/aa-good.png"
                  alt=""
                  class="tale-good-pic m_b20"
                  @click="voteLike"
                  v-else
                />
                <div class="font-size28 color_FF">{{ data.likeNum }}</div>
              </div>
              <div class="my_text_center tale-good m_b50">
                <img
                  src="@/assets/images/my-collec.png"
                  alt=""
                  class="tale-good-pic m_b20"
                  @click="voteCollection"
                  v-if="isCollection"
                />
                <img
                  src="@/assets/images/aa-collection.png"
                  alt=""
                  class="tale-good-pic m_b20"
                  @click="voteCollection"
                  v-else
                />
                <div class="font-size28 color_FF">{{ data.collectNum }}</div>
              </div>
              <div class="my_text_center tale-good m_b50">
                <img
                  src="@/assets/images/share.png"
                  alt=""
                  class="tale-good-pic m_b20"
                  @click="share"
                />
                <div class="font-size28 color_FF">分享</div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { getMyCollection } from "@/store/getData.js";

export default {
  data() {
    return {
      layout: "qeqewqeqweqeqadazczcadaq",
      status: 2,
      nowLayout: [],
      mode: "vertical-rl",
      list: [],
      loading: false,
      finished: false,

      pageNum: 1,
      pageSize: 10,
      totalPage: null,
    };
  },
  created() {},
  mounted() {
    this.getMyCollectionList();
  },
  methods: {
    getMyCollectionList() {
      getMyCollection({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }).then((res) => {
        this.totalPage = res.data.totalPage;
        if (res.code == 200) {
          if (this.pageNum >= res.data.totalPage) {
            this.finished = true;
            this.loading = false;
            this.list.push(...res.data.list);
          } else {
            this.finished = false;
            this.loading = false;
            this.list.push(...res.data.list);
          }
        }
      });
    },

    checkInfo(id) {
      this.$router.push({ path: "/myTaleInfo", query: { data: id } });
    },

    onLoad() {
      if (this.pageNum >= this.totalPage) {
        this.finished = true;
        this.loading = false;
      } else {
        this.finished = false;
        this.loading = true;
        this.pageNum++;
        this.getMyCollectionList();
      }
    },
  },
};
</script>
